import * as actionTypes from '../../actionTypes';

// utilities
import _ from 'lodash';

// initial state
export const initialState = {};


export default function referenceReducer(state = initialState, {type, ...action}) {
  switch (type) {
    case actionTypes.UPDATE_APPLICANT :
      if(action.references && action.references !== state) {
        // don't allow 'isNew' to enter store, get rid of properties with value of Symbol.for('__delete')
        return _({...state})
          .merge(_.omit(action.references, 'isNew'))
          .omitBy(val => val === Symbol.for('__delete'))
          .value();
      }

    case actionTypes.DELETE_FROM_APPLICANT_LIST :
      // remove clientId property from state
      return _.omit(state, action.clientId);

    case actionTypes.CLEAR_APPLICANT :
    case actionTypes.LOG_OUT :
      return {};

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./shared/redux/reducers/references/index.js